<template>
  <div class="animated fadeIn">
    <SubHeaderDeleted></SubHeaderDeleted>
    <DataTable :editable="editable" :eventStatus="eventStatus"></DataTable>
  </div>
</template>

<script>
  import data from '../_data';
  import SubHeaderDeleted from '../components/subHeaders/SubHeaderDeleted';
  import DataTable from '../components/datatable/DataTable';
  import consts from '../_consts';

  export default {
    name: 'deleted',
    components: {
      SubHeaderDeleted,
      DataTable
    },
    data () {
      return {
        currentPage: 1,
        perPage: 5,
        totalRows: data.items.length,
        pageOptions: [
          {text: 5, value: 5},
          {text: 10, value: 10},
          {text: 15, value: 15}
        ],
        sortBy: null,
        sortDesc: false,
        filter: null,
        modalDetails: {index: '', data: ''},
        eventStatus: consts.eventStatus.deleted
      };
    },
    methods: {},
    computed: {
      editable () {
        return false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Deleted.vue?75bd4064